import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Box, TextField, Button, Alert
} from '@mui/material';
import { AutoAwesome as GenerateIcon } from '@mui/icons-material';

export default function GeneratePeriodsDialog({
  open, onClose, onGenerate,
  generateForm, setGenerateForm,
  periodTypeLabel
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Generate Pay Periods</DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Alert severity="info">
            Periods will be generated based on your current settings ({periodTypeLabel}).
          </Alert>
          <TextField
            label="Number of Periods"
            type="number"
            value={generateForm.count}
            onChange={(e) => setGenerateForm({
              ...generateForm,
              // Server cap (Gitea #139): 1..120 per run.
              count: Math.min(Math.max(parseInt(e.target.value) || 1, 1), 120),
            })}
            fullWidth
            inputProps={{ min: 1, max: 120 }}
            helperText="1 to 120 periods per run"
          />
          <TextField
            label="Starting Date (Optional)"
            type="date"
            value={generateForm.start_date}
            onChange={(e) => setGenerateForm({ ...generateForm, start_date: e.target.value })}
            fullWidth
            InputLabelProps={{ shrink: true }}
            helperText="Leave blank to start from today"
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onGenerate} variant="contained" startIcon={<GenerateIcon />}>
          Generate
        </Button>
      </DialogActions>
    </Dialog>
  );
}
